(function($) {
    $(function() {
        //Don`t show subscribe to push widget if browser is not chrome and chrome version less than 42
        var $subscribeToPushContainer = $('.subscribe-to-push__container');

        if (!isPushEnabled()) {
            $subscribeToPushContainer.addClass('disabled');
        }

        //Show different text in subscribe to push widget by get parameter
        var subscribeToPushReturnedValue = getUrlParameter('saction');

        var subscribeToPushTitle = $('.pusher__title');
        if (!subscribeToPushReturnedValue || subscribeToPushReturnedValue == "back") {
            subscribeToPushTitle.html(subscribeToPushTitle.data('pusherTitleDefault'));
        } else if (subscribeToPushReturnedValue == "subscribe") {
            subscribeToPushTitle.html("Вы успешно подписаны на получение уведомлений!");
        } else if (subscribeToPushReturnedValue == "unsubscribe") {
            subscribeToPushTitle.html("Вы отписаны от получения уведомлений.");
        }

        // set focus in search query element automatically
        $('.header__search').Toggler({
            disableOnScrollHiding: true,
            onShow: function(toggler) {
                var queryElement = toggler.element.data('query-element');

                if (!queryElement) {
                    var selector = toggler.element.data('query-element-selector');

                    if (selector && (queryElement = toggler.element.find(selector)).length > 0) {
                        queryElement = queryElement.get(0);
                        toggler.element.data('query-element', queryElement);
                    }
                }

                if (queryElement) {
                    setTimeout(function() {
                        queryElement.focus();
                    }, 100);
                }
            }
        });

        $('.scroll-to-top-button').ScrollToTopButton();

        //navigation expanded for mobile
        var $navigationExpandedContainer = $(".nav_expanded");
        var $navigationExpandedBtn = $(".nav_expanded__main-link");
        var $navigationExpandedItems = $(".nav_expanded__items");

        $navigationExpandedBtn.on("click", function() {
            if ($navigationExpandedItems.css('display') == 'none') {
                $navigationExpandedItems.fadeIn("fast");
            } else {
                $navigationExpandedItems.fadeOut("fast");
            }
        });

        $('body').on('mouseup', function(e) {
            if (!$navigationExpandedContainer.is(e.target)
                && $navigationExpandedContainer.has(e.target).length === 0
            ) {
                $navigationExpandedItems.fadeOut("fast");
            }
        });

        /*Оборачиваем в div все таблицы в новости, чтобы они не ломали адаптивную верстку*/
        $('.story__text table').wrap('<div class="table_responsive"></div>');

        //Function to get url parameter
        function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1];
                }
            }
        }

        //Function get browser name and version
        function getBrowser(){
            var userAgent = navigator.userAgent;
            var temp;
            var result = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

            if(/trident/i.test(result[1])) {
                temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
                return {
                    name: 'IE',
                    version: (temp[1] || '')
                };
            }

            if(result[1] === 'Chrome') {
                temp = userAgent.match(/\bOPR\/(\d+)/)
                if (temp != null) {
                    return {
                        name: 'Opera',
                        version: temp[1]
                    };
                }
            }

            result = result[2]? [result[1], result[2]]: [navigator.appName, navigator.appVersion, '-?'];

            if((temp = userAgent.match(/version\/(\d+)/i)) != null) {
                result.splice(1, 1, temp[1]);
            }

            return {
                name: result[0],
                version: result[1]
            };
        }

        //Проверяем по названию и версии браузера, можем ли мы отсылать пуш уведомления
        //К сожалению мы не можем просо проверить есть ли у браузера serviceWorkers и PushManager
        //Потому что нашему пушеру нужны еще дополнительные проверки, а мы не можем показать блок,
        //а потом в пушере послать пользователя нафиг
        function isPushEnabled() {
            var browserInfo = getBrowser();

            return (browserInfo.name == 'Chrome' && browserInfo.version >= 42) ||
                (browserInfo.name == 'Firefox' && browserInfo.version >= 44);
        }

        if (typeof window.dante !== 'undefined') {
            const dante = window.dante;
            const danteInstance = new dante;
            const danteVisiblePlaces = $('div[data-zone-id]:visible');

            for (let i = 0; danteVisiblePlaces.length > i; i++) {
                const id = danteVisiblePlaces[i].dataset.hasOwnProperty('id') ? danteVisiblePlaces[i].dataset.id : danteVisiblePlaces[i].dataset.zoneId;
                danteInstance.addPlace(danteVisiblePlaces[i], parseInt(id));
            }
            danteInstance.update();
        }
    });
})(jQuery);
